(function (window, document, $) {

    $(document).ready(function () {
        /* if ( $( '.footer__newsletter-signup .field__wrapper--nieuwsbrieven' ).length > 0 ) {  
             $( '.footer__newsletter-signup .field__wrapper--nieuwsbrieven input:checkbox' ).prop( 'checked', true ); 
             $( '.footer__newsletter-signup .field__wrapper--tekstcommercieelmailenvraag input:checkbox' ).prop( 'checked', true ); 
        }*/

        // gravity forms aanpassingen ==================================================================================

        // zet verborgen velden ook op readonly zodat de prijs niet aangepast kan worden
        $('.gf-hide input').prop('readonly', true);

        // geef datum velden met de class hasEventDate de mogelijkheid om een datum in de toekomst te selecteren
        if($(".gform_wrapper .hasEventDate input.datepicker").length) { 
            $(".gform_wrapper .hasEventDate input.datepicker").datepicker("option", "defaultDate", null);
            $(".gform_wrapper .hasEventDate input.datepicker").datepicker("option", "minDate", "-2y");
            $(".gform_wrapper .hasEventDate input.datepicker").datepicker("option", "maxDate", "+2y");
            $(".gform_wrapper .hasEventDate input.datepicker").datepicker("option", "yearRange", "-2:+2");
        }
    });

}(window, document, jQuery));
